var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCodata(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 177.4 29.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 3,
    y1: 10.7,
    x2: 20.1,
    y2: 22.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#022454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#033775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#034289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#045db8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0471d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#047dee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 2.6,
    y1: 14.5,
    x2: 28.4,
    y2: 14.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#022454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#033775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#034289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#045db8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0471d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#047dee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0582f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 80.3,
    y1: 50.3,
    x2: 80.3,
    y2: -0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#022454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#022555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#02285c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#022f68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#033775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#034289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#045db8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0471d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#047dee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0582f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 105.1,
    y1: 50.3,
    x2: 105.1,
    y2: -0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 127.1,
    y1: 50.3,
    x2: 127.1,
    y2: -0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 146.5,
    y1: 50.3,
    x2: 146.5,
    y2: -0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 166,
    y1: 50.3,
    x2: 166,
    y2: -0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 55.4,
    y1: 50.3,
    x2: 55.4,
    y2: -0.5,
    xlinkHref: "#f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6,17.5C2.6,10.4,10.1.9,20.7,6.6c3.9,2.1,6.6-1.9,3.8-3.8-2.5-1.8-5.7-2.8-9.1-2.8C6.9,0,0,6.6,0,14.7s3,10,7.4,12.6c-2.9-2.6-4.8-6.2-4.8-9.8Z",
    style: {
      fill: "#0582f6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1,14.1c-.1,7.1,6.7,12.3,14.4,8.9,4.1-1.8,6.5,2.3,3.5,4.1-2.7,1.6-5.9,2.4-9.3,2.1-8.5-.6-12.5-6.5-11.9-14.6.4-5.3,6.2-9.9,12.2-9.7-6.1.7-8.8,5.6-8.9,9.2Z",
    style: {
      fill: "url(#d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8,
    cy: 4.8,
    r: 3.2,
    style: {
      fill: "#0582f6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8,
    cy: 24.3,
    r: 3.2,
    style: {
      fill: "#0582f6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,6.9c-1.8,0-3.5.6-4.8,1.7-.2.1-.4.3-.6.4-.1.1-.3.3-.5.4-.9.7-2.1,2.7-3.4,2.7s-1.7-.4-2.6-1.2c-.2-.1-.4-.3-.5-.4-.9-.7-2.1-1.2-3.4-1.2-3,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5,2.4-.4,3.4-1.2c.2-.2.3-.3.5-.4.9-.7,1.3-1.2,2.6-1.2s2.5,1.2,3.4,2c.2.1.3.3.5.4.1,0,.2.2.3.2,1.3,1.2,3.1,1.9,5,1.9,4.2,0,7.6-3.4,7.6-7.6s-3.4-7.6-7.6-7.6Z",
    style: {
      fill: "url(#e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3,3.3c-3.2,0-5.9,1.1-8.1,3.3-2.2,2.2-3.3,4.9-3.3,8s1.1,5.8,3.3,8c2.2,2.2,4.9,3.3,8.1,3.3s5.9-1.1,8.1-3.3c2.2-2.2,3.3-4.8,3.3-8s-1.1-5.8-3.3-8c-2.2-2.2-4.9-3.3-8.1-3.3ZM85.3,19.7c-1.3,1.4-3,2-4.9,2s-3.6-.7-4.9-2c-1.3-1.4-2-3-2-5.1s.7-3.7,2-5.1c1.3-1.4,3-2.1,4.9-2.1s3.6.7,4.9,2.1c1.3,1.4,2,3.1,2,5.1s-.7,3.7-2,5.1Z",
    style: {
      fill: "url(#f)",
      isolation: "isolate",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.8,6.8c-2.2-2-5-3-8.6-3h-7.9v21.6h7.9c3.6,0,6.4-1,8.6-3s3.3-4.6,3.3-7.8-1.1-5.8-3.3-7.8ZM108.6,19.5c-1.4,1.2-3.2,1.9-5.4,1.9h-3.6V7.8h3.6c2.3,0,4.1.6,5.4,1.9,1.4,1.2,2,2.9,2,5s-.7,3.7-2,5Z",
    style: {
      fill: "url(#g)",
      isolation: "isolate",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,3.8l-9.3,21.6h4.7l1.9-4.6h9.5l1.9,4.6h4.7l-9.3-21.6h-4.1ZM123.9,16.8l3.2-7.7,3.1,7.7h-6.3Z",
    style: {
      fill: "url(#h)",
      isolation: "isolate",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.9 3.8 137.2 3.8 137.2 7.8 144.3 7.8 144.3 25.4 148.7 25.4 148.7 7.8 155.9 7.8 155.9 3.8",
    style: {
      fill: "url(#i)",
      isolation: "isolate",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,3.8h-4.1l-9.3,21.6h4.7l1.9-4.6h9.5l1.9,4.6h4.7l-9.3-21.6ZM162.8,16.8l3.2-7.7,3.1,7.7h-6.3Z",
    style: {
      fill: "url(#j)",
      isolation: "isolate",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8,7.4c1.6,0,2.9.5,4.1,1.4.7.6,1,1.5,1.7,2.3s2.2.9,3,.8,1.1-.3,1.7-.8c-.6-2.3-1.8-4.1-3.6-5.5-2-1.5-4.2-2.2-6.9-2.2s-5.9,1.1-8,3.3c-2.2,2.2-3.3,4.8-3.3,8s1.1,5.8,3.3,8c2.2,2.2,4.9,3.3,8,3.3s5-.8,6.9-2.3c1.6-1.3,2.8-3,3.4-5-.5-.3-1.1-.4-1.5-.4-1,0-2.8.3-3.7,1.2-.4.4-.7.8-1.1,1.1-1.1.9-2.5,1.4-4.1,1.4s-3.6-.7-4.9-2.1c-1.3-1.4-2-3.1-2-5.1s.7-3.7,2-5.1c1.3-1.4,3-2,4.9-2Z",
    style: {
      fill: "url(#k)",
      isolation: "isolate",
      strokeWidth: 0
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCodata);
export default __webpack_public_path__ + "static/media/logo-codata.369a87dd3a3497c91fe18c2c31132866.svg";
export { ForwardRef as ReactComponent };